import type { Article, HelpAudience, HelpSection } from './types'
import { GENERAL_ARTICLES } from './articles-general'
import { FIELD_ARTICLES } from './articles-field'
import { OFFICE_TIME_ARTICLES } from './articles-office-time'
import { OFFICE_SETUP_ARTICLES } from './articles-office-setup'
import { CERT_ARTICLES } from './articles-certs'

export type { Article } from './types'

export const ARTICLES: Article[] = [
  ...GENERAL_ARTICLES,
  ...FIELD_ARTICLES,
  ...OFFICE_TIME_ARTICLES,
  ...OFFICE_SETUP_ARTICLES,
  ...CERT_ARTICLES,
]

export const SECTIONS: HelpSection[] = [
  'Getting started',
  'Crew time (field)',
  'Office: time and pay',
  'Office: setup',
  'Certifications',
  'Reference',
]

export function articleBySlug(slug: string | undefined): Article | undefined {
  return ARTICLES.find((a) => a.slug === slug)
}

/** What the person can open: their role, and whether Certifications is open to them. */
export interface HelpViewer {
  role: string | undefined
  certs: boolean
}

/** Is this article for this person? Admin sees everything. Tidiness, not
 *  security -- the screens enforce who may do what. */
export function isFor(a: Article, v: HelpViewer): boolean {
  const aud: HelpAudience = a.audience
  if (v.role === 'Admin') return true
  if (aud === 'all') return true
  if (aud === 'field') return v.role === 'Supervisor'
  if (aud === 'office') return v.role === 'Office'
  return v.certs
}

const MODULE_HOME = /^\/(field|office|certs)$/

/**
 * The "?" article for a screen. Prefix match, longest wins, so
 * '/office/jobs' covers '/office/jobs/N12022'; a module home only matches
 * itself. Falls back to the welcome article.
 */
export function articleForPath(path: string): Article {
  let best: { a: Article; len: number } | undefined
  for (const a of ARTICLES) {
    for (const r of a.routes ?? []) {
      const hit = MODULE_HOME.test(r) ? path === r : path === r || path.startsWith(`${r}/`)
      if (hit && (!best || r.length > best.len)) best = { a, len: r.length }
    }
  }
  return best?.a ?? articleBySlug('welcome') ?? ARTICLES[0]
}
